<template>
  <div v-if="item.latest_transfer_note_info && item.latest_transfer_note_info.transfer_note_no">
    <div>
      <a href="javascript:void(0)" @click="onEditClick" v-if="$hasPermission('change_transfernote')">
        {{ item.latest_transfer_note_info.transfer_note_no }}
      </a>
      <span v-else>
        {{ item.latest_transfer_note_info.transfer_note_no }}
      </span>
      <span class="badge bg-white border ml-1 hover-cursor" @click="onPdfViewClick"
            v-b-tooltip.hover.right="$t('View PDF')">
        <font-awesome-icon icon="file-pdf"/>
      </span>
    </div>
    <div v-as-status="item.latest_transfer_note_info.status">
      {{ item.latest_transfer_note_info.status | removeUnderscores | toUpperCaseEveryWord | translate }}
    </div>
    <div v-if="item.latest_transfer_note_info.origin_item_location">
      <b>From</b>: {{ item.latest_transfer_note_info.origin_item_location.name }}
    </div>
    <div v-if="item.latest_transfer_note_info.destination_item_location">
      <b>To</b>: {{ item.latest_transfer_note_info.destination_item_location.name }}
    </div>
    <div v-if="item.latest_transfer_note_info.title">
      {{ item.latest_transfer_note_info.title  | truncate(50) }}
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import {SOURCE_TRANSFER_NOTES_TABLE} from "@/modules/constants";

  const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

  const {mapActions} = createNamespacedHelpers('transferNotes');

  export default {
    name: "TransferNoteShortInfo",
    props: ['item', 'source'],
    methods: {
      ...mapActions(['showModal', 'getModalObject']),
      ...mapActionsGlobal([
        'showGeneralContractModal',
        'getGeneralContractModalData',
      ]),
      onEditClick() {
        this.showModal({source: this.source})
        this.getModalObject({uuid: this.item.latest_transfer_note_info.uuid, source: this.source});
      },
      onPdfViewClick() {
        this.getGeneralContractModalData({
          object: this.item.latest_transfer_note_info,
          fileType: 'transfer_note_contract',
          objectName: 'transfernote',
        });
        this.showGeneralContractModal({
          source: SOURCE_TRANSFER_NOTES_TABLE,
          object: this.item.latest_transfer_note_info,
          fileType: 'transfer_note_contract',
          objectName: 'transfernote',
          enableESignature: true,
          refreshOnSubmit: true,
          modalTitle: this.$i18n.t("Transfer Note")
        })
      }
    }
  }
</script>

<style scoped>

</style>
